module.exports = __webpack_public_path__ + "img/redness_2.74550aaa.png";